import React, {FC} from "react";
import firebase from "firebase";
import {AuthContext} from "../../auth/components/AuthProvider";
import {Button, CircularProgress, Container, TextField, Typography} from "@material-ui/core";

export const InitialChangePassword: FC = ({children}) => {

    const {userId} = React.useContext(AuthContext);

    const [pwResetted, setPasswordResetted] = React.useState(true);

    const [oldPw, setOldPw] = React.useState("");

    const [password, setPassword] = React.useState("");

    const [pwConfirmation, setPwConfirmation] = React.useState("");

    const [error, setError] = React.useState<string | null>(null);

    const [isLoading, setIsLoading] = React.useState(false);

    const changePassword = () => {

        const currentUser = firebase.auth().currentUser;

        if (currentUser && currentUser.email) {
            if (password === "") {
                setError("Passwort nicht gesetzt");
                return;
            }
            if (password !== pwConfirmation) {
                setError("Passwörter nicht gleich");
                return;
            }
            setIsLoading(true);
            setError(null);

            const cred = firebase.auth.EmailAuthProvider.credential(currentUser.email, oldPw);

            currentUser.reauthenticateWithCredential(cred).then(() => {
                currentUser.updatePassword(password).then(() => {
                    setPasswordResetted(true);
                    firebase.firestore()
                        .collection("initialPwReset")
                        .doc(currentUser.uid)
                        .set({passwordResetted: true})
                        .then(() => setIsLoading(false))
                })
                    .catch((err) => {
                        setIsLoading(false);
                        if(err.code === "auth/weak-password") {
                            setError("Passwort muss mindestens 6 Zeichen lang sein.");
                        }
                    })
            })
        }
    }

    React.useEffect(() => {
        if (userId) {
            firebase.firestore()
                .collection("initialPwReset")
                .doc(userId)
                .get()
                .then(s => setPasswordResetted(s.exists))
        }
    }, [userId]);

    return (
        pwResetted
            ? <React.Fragment>{children}</React.Fragment>
            : (
                <Container style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "100vh"
                }}>
                    <Typography variant="h3" color="secondary">Herzlich Willkommen</Typography>
                    <Typography variant="h5" color="secondary">Bitte ändere dein Passwort</Typography>
                    <TextField
                        type="password"
                        label="Altes Passwort"
                        onChange={(e) => setOldPw(e.target.value)}
                        style={{marginTop: 16}}
                    />
                    <TextField
                        type="password"
                        label="Neues Passwort"
                        onChange={(e) => setPassword(e.target.value)}
                        style={{marginTop: 16, marginBottom: 16}}
                    />
                    <TextField
                        type="password"
                        label="Passwort bestätigen"
                        onChange={(e) => setPwConfirmation(e.target.value)}
                        style={{marginBottom: 32}}
                    />
                    {error && <Typography color="error" style={{marginBottom: 16}}>{error}</Typography>}
                    {isLoading
                        ? <CircularProgress/>
                        : <Button variant="contained" color="primary" onClick={changePassword}>
                            Speichern
                        </Button>}
                </Container>
            )
    )
}
